import React, {useEffect, useState} from 'react';
import * as RestService from '../../services/eisRest';
import  ProcessedOperationsDatatable from './ProcessedOperationsDatatable';
import ProcessingModal from './ProcessingModal';




const DocumentOperationsProcessingDetailListTab = (props) => {

    
  const [show , setShow]= useState( false );
  const [showProcessingModal, setShowProcessingModal] = useState(false);
  const [selectedRecord, setSelectedRecord ] = useState();    
  const [workOrderId, setWorkOrderId ] = useState();    
  const [operationId, setOperationId ] = useState();    
  const [checkTime, setCheckTime] = useState(null);
  const [showAndRecordId, setShowAndRecordId] = useState(
    {
      show: false,
      workOrderId: '',
      operationId: '',
      selectedRecord: ''
    }
  );



  
   
    

    const handleCallbackProcessingModal = (show,id) => {         
      setShowAndRecordId({
        show: show,
     //   workOrderId: '',
       // operationId: '',
        selectedRecord: id
      });
      setCheckTime(Date.now());
      props.parentCallback(id);
    };

  const handleCallback = (id) => {      
        
    if (typeof(id) !== 'undefined' && id != null) {       
       
            
            RestService.callAnyApi('operation/getProcessOperation?id='+id, null)
            .then((data) => {
                          
              setShowAndRecordId({
                show: true,
                workOrderId: data.workOrderId,
                operationId: data.workOrderItemId,
                selectedRecord: id
              });
           //   setArticle(data); 
          })
          .catch((error) => {
            console.log(error);
          });
        
    }
  };

  const modalCallback = (show,id) => {             
    //  setRecordId(id);  
      setShow(show);          
   
  }



  useEffect(() => {      
    setCheckTime(Date.now());
  }, [props.isActive])


  return (
      <div className={`tab-pane ${props.isActive ? 'active' : ''}`}>          
      
        <ProcessedOperationsDatatable    
          parentCallback={handleCallback}  
          modalCallback={modalCallback}  
          modalShow={show}    
          checkTime={checkTime}         
          selectedRecord={props.selectedRecord}                   
        />
       
         <ProcessingModal
               modal={showAndRecordId.show}
               parentCallback={handleCallbackProcessingModal}
               workOrderId={showAndRecordId.workOrderId}                      
               operationId={showAndRecordId.operationId} 
               selectedRecord={showAndRecordId.selectedRecord}                             
           />
       
      </div>
  );
};

export default DocumentOperationsProcessingDetailListTab;